import React, {
  Fragment
} from 'react';
import PropTypes from 'prop-types';
import UserRoleCheckbox from './UserRoleCheckbox';
import ReliableRequest from '../../../../lib/ReliableRequest';
import { permittedFields, descriptions } from '../../../../constants/UserRole'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
class CreateRole extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCompleted: false,
      name: "",
      inputNameError: false,
      fields: {
        sms_notif: true,
        call_notif: true,
        callback_notif: true,
        custom_event_notif: true,
        owner_change_notif: true,
        global_owner_notifications: false,
        audio: true,
        push_notif_enabled: true,
        push_notif_new: false,
        push_notif_global: false,
        template_hotkeys_enabled: true,
        embedded_vars_enabled: true
      }
    };
  }
  updateResult = (name, e) => {
    if (permittedFields.includes(name)) {
      this.setState(prevState => ({
        fields: {
          ...prevState.fields,
        [name]: e
        }
      }));
    } else {
      console.error("Unpermitted field: " + name)
    }
  }
  onSubmit = () => {
    if (this.state.name.length === 0) {
      document.querySelector("#account-members").scrollTo(0, 0)
      this.setState({
        inputNameError: true
      });
    } else {
      ReliableRequest.dispatch({
        url: this.props.action,
        method: 'POST',
        data: {
          authenticity_token: this.props.authenticityToken,
          user_role: {
            name: this.state.name,
            sms_notif: this.state.fields.sms_notif,
            call_notif: this.state.fields.call_notif,
            callback_notif: this.state.fields.callback_notif,
            custom_event_notif: this.state.fields.custom_event_notif,
            owner_change_notif: this.state.fields.owner_change_notif,
            global_owner_notifications: this.state.fields.global_owner_notifications,
            audio: this.state.fields.audio,
            push_notif_enabled: this.state.fields.push_notif_enabled,
            push_notif_new: this.state.fields.push_notif_new,
            push_notif_global: this.state.fields.push_notif_global,
            template_hotkeys_enabled: this.state.fields.template_hotkeys_enabled,
            embedded_vars_enabled: this.state.fields.embedded_vars_enabled,
          }
        },
        onSuccess: (data) => {
          this.setState({
            isCompleted: true,
          });
        },
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.isCompleted &&
          <Redirect to="/" />
        }
        <div className='heading'>
          <Link to="/" className="back-btn"></Link>
          <h3>New Role</h3>
        </div>
        <div className="card">
          <div className="row">
            <div className="col-6">
              <p className="role-desc">Name your role</p>
            </div>
            <div className="col-6">
              <div className="role-name">
                <input type="text" placeholder="Ex: Support Agent" onChange={(event) => this.setState({name: event.target.value})}/>
                {this.state.inputNameError &&
                  <span className="input-error">Enter a name for your role</span>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          {Object.entries(this.state.fields).map(([key]) =>
            <UserRoleCheckbox
              updateResult={this.updateResult}
              description={descriptions[key]}
              checkboxName={key}
              enabled={this.state.fields[key]}
              updateStatus={false}
            />
          )}
        </div>
        <div className="button-container">
        <button className="button-send" onClick={() => this.onSubmit()}>Create Role</button>
        </div>
      </div>
    )
  }
}
CreateRole.propTypes = {
  action: PropTypes.string,
  authenticityToken: PropTypes.string,
};
export default CreateRole

